export enum UserResourceType {
  AccountResource = 'AccountResource',
  CustomResource = 'CustomResource',
}
